export function formatDateTime(date) {
    if (!date) return '';

    return date.substring(0, 10) + ' ' + date.substring(11, 16);
}